"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["aria-label", "aria-labelledby"];
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const HintText_vue_1 = __importDefault(require("../SharedForm/HintText.vue"));
const ValidationText_vue_1 = __importDefault(require("../SharedForm/ValidationText.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedRadioGroup',
    props: {
        chip: { type: Boolean },
        innerClass: {},
        displayName: {},
        hint: {},
        hintPermanent: { type: Boolean },
        modelValue: {},
        name: {},
        required: { type: Boolean },
        forcedErrorMessage: {},
        requiredErrorMessage: {},
        label: {},
        ariaLabel: {},
        disableErrorMessages: { type: Boolean },
        dataTestName: { default: "" },
        displayModeVertical: { type: Boolean },
        displayModeHorizontal: { type: Boolean },
        displayModeHorizontalRadiobuttons: { type: Boolean }
    },
    emits: ["update:modelValue", "change-error-msg"],
    setup(__props, { emit: __emit }) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const props = __props;
        const emit = __emit;
        const checkedRadio = (0, vue_3.ref)(props.modelValue ? props.modelValue : null);
        (0, vue_3.watchEffect)(() => {
            emit("update:modelValue", checkedRadio.value || null);
        });
        (0, vue_3.watch)(() => props.modelValue, (newValue) => {
            checkedRadio.value = newValue;
            updateFormValidity();
        });
        const isValidationVisible = (0, vue_3.ref)(!props.disableErrorMessages && !!props.forcedErrorMessage);
        const updateFormValidity = (0, vue_3.inject)("updateFormValidity", () => { });
        const requiredMessage = (0, vue_3.computed)(() => {
            if (!isValidationVisible.value)
                return "";
            const fieldName = props.displayName || props.name || t("shared.radio.defaultField");
            return (props.forcedErrorMessage || props.requiredErrorMessage || t("shared.radio.requiredError", { field: fieldName }));
        });
        const updateInputValidityState = (fieldErrorMessage, isValidationOnFieldVisible) => {
            isValidationVisible.value =
                !props.disableErrorMessages && (!!props.forcedErrorMessage || !!isValidationOnFieldVisible);
        };
        (0, vue_3.provide)("radioGroupName", props.name);
        (0, vue_3.provide)("isRadioGroupChip", props.chip);
        (0, vue_3.provide)("checkedRadio", checkedRadio);
        (0, vue_3.provide)("isRadioGroupRequired", (0, vue_3.toRef)(props, "required"));
        (0, vue_3.provide)("forcedErrorMessage", props.forcedErrorMessage);
        (0, vue_3.provide)("updateInputValidityState", updateInputValidityState);
        (0, vue_3.provide)("updateCheckedRadio", (value) => {
            checkedRadio.value = value;
            updateFormValidity();
        });
        const isHintVisible = (0, vue_3.computed)(() => props.hintPermanent || !isValidationVisible.value);
        (0, vue_3.watch)([isValidationVisible, requiredMessage], () => {
            emit("change-error-msg", event, { errorMessage: requiredMessage.value });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "tw text-sm",
                role: "radiogroup",
                "aria-label": _ctx.ariaLabel && !_ctx.label ? _ctx.ariaLabel : undefined,
                "aria-labelledby": _ctx.label ? 'salutation_label' : undefined
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)({ 'flex items-center gap-4': _ctx.displayModeHorizontal })
                }, [
                    (_ctx.label)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", {
                            key: 0,
                            id: "salutation_label",
                            class: (0, vue_2.normalizeClass)({ 'mb-2': !_ctx.displayModeHorizontal })
                        }, (0, vue_2.toDisplayString)(_ctx.label), 3))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)([
                            _ctx.innerClass,
                            {
                                'flex items-center gap-4': _ctx.displayModeHorizontalRadiobuttons || _ctx.displayModeHorizontal,
                                'flex flex-wrap gap-2': _ctx.chip,
                                'flex flex-col gap-2': _ctx.displayModeVertical,
                            },
                        ])
                    }, [
                        (0, vue_2.renderSlot)(_ctx.$slots, "default")
                    ], 2)
                ], 2),
                (_ctx.hint && isHintVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(HintText_vue_1.default, {
                        key: 0,
                        "hint-text": _ctx.hint,
                        "no-indent": ""
                    }, null, 8, ["hint-text"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (isValidationVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ValidationText_vue_1.default, {
                        key: 1,
                        class: "pt-2",
                        "data-test-name": _ctx.dataTestName,
                        "error-message": requiredMessage.value,
                        "no-indent": ""
                    }, null, 8, ["data-test-name", "error-message"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
